import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAppSelector } from '../../hooks/redux.hooks';
import MaintenancePage from '../../pages/MaintenancePage';
import axios from 'axios';
import config from '../../config';

interface PrivateRouteProps {
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ children }) => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const token = useAppSelector((state) => state.auth.token);
  const user = useAppSelector((state) => state.auth.user);
  const [maintenanceMode, setMaintenanceMode] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    checkMaintenanceMode();
    // Check every 30 seconds so maintenance mode applies quickly
    const interval = setInterval(checkMaintenanceMode, 30000);

    // Listen for immediate 503 from any API call
    const handleMaintenance = () => setMaintenanceMode(true);
    window.addEventListener('maintenance-mode-activated', handleMaintenance);

    return () => {
      clearInterval(interval);
      window.removeEventListener('maintenance-mode-activated', handleMaintenance);
    };
  }, []);

  const checkMaintenanceMode = async () => {
    try {
      const response = await axios.get(`${config.API_BASE_URL}/Database/maintenance`);
      setMaintenanceMode(response.data.maintenanceMode);
    } catch {
      // If can't reach server, continue normally
      setMaintenanceMode(false);
    } finally {
      setChecked(true);
    }
  };

  // Check if user is authenticated
  if (!isAuthenticated || !token) {
    return <Navigate to="/login" replace />;
  }

  // Wait for maintenance check
  if (!checked) return null;

  // If maintenance mode is ON and user is NOT Super Admin → show maintenance page
  if (maintenanceMode && !user?.isSuperAdmin) {
    return <MaintenancePage />;
  }

  return <>{children}</>;
};

export default PrivateRoute;